import styled from 'styled-components';

import { black, blue } from '@bufferapp/ui/style/colors';

export const Holder = styled.div`
  display: flex;
  flex-direction: column;
  width: 800px;
  height: 385px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: top 35px right 15px;
  background-image: url('https://buffer-publish.s3.amazonaws.com/images/illustration-publishing.png');
  background-size: 360px;
  padding: 24px;

  p,
  h1 {
    color: ${black};
  }

  h1 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;

export const Content = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;

  p {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  ol {
    list-style: none;
    padding: 0;
    margin-top: 24px;
    margin-bottom: 24px;

    li {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;

      svg {
        color: ${blue};
        margin-right: 6px;
      }
    }
  }
`;

export const Ctas = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  div[type='primary'] {
    margin-right: 8px;
  }
`;

export const CtaText = styled.div`
  width: 100%;
  margin-top: 20px;
  font-size: 14px;
`;
